<template>
  <div id='bd-main'>
    <el-table :data="historyRecordsThreads.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="tid" label="唯一Tid"></el-table-column>
      <el-table-column prop="nickname" label="姓名" width="185"></el-table-column>
      <el-table-column prop="content" label="内容"></el-table-column>
      <el-table-column prop="type" label="类型"></el-table-column>
      <el-table-column prop="client" label="客户端"></el-table-column>
      <el-table-column prop="timestamp" label="会话时间"></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <!-- <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small">
            查看
          </el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="historyRecordsThreads.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      resize: true
    }
  },
  computed: {
    ...mapGetters([ 'historyRecordsThreads' ])
  },
  methods: {
    ...mapActions([ 'getThreadHistoryRecords' ]),
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let payload = { page: val - 1, size: 10 }
    this.getThreadHistoryRecords(payload)
    }
  },
  created() {
    let payload = { page: 0, size: 10 }
    this.getThreadHistoryRecords(payload)
  },

}
</script>

<style scoped>

</style>
